var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 483.2 483.2",
    style: {
      enableBackground: "new 0 0 483.2 483.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "33.6,0 33.6,352 163.2,480 449.6,480 449.6,0 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#E9F4F3"
    },
    points: "449.6,480 449.6,0 33.6,0 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#D4E8E5"
    },
    points: "449.6,224 449.6,0 33.6,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6E5E3"
    },
    points: "289.6,480.8 161.6,352 161.6,480 289.6,480 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8AC4BD"
    },
    points: "33.6,352 161.6,483.2 161.6,352 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#67A59C"
    },
    points: "82.4,402.4 161.6,483.2 161.6,352 95.2,413.6 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1589AD"
    },
    points: "384.8,336.8 303.2,343.2 222.4,336.8 303.2,176.8 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#035670"
    },
    points: "303.2,176.8 384.8,336.8 303.2,343.2 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1EA4C4"
    },
    points: "303.2,314.4 349.6,268 324,216.8 303.2,196 283.2,216.8 256.8,268 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#066B93"
    },
    points: "303.2,314.4 349.6,268 324,216.8 303.2,196 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1589AD"
    },
    points: "338.4,332.8 218.4,343.2 98.4,332.8 218.4,97.6 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#057091"
    },
    points: "218.4,97.6 338.4,332.8 218.4,343.2 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1EA4C4"
    },
    points: "218.4,300.8 286.4,232.8 248,156.8 218.4,126.4 188.8,156.8 149.6,232.8 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#1290AD"
    },
    points: "218.4,300.8 286.4,232.8 248,156.8 218.4,126.4 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9ADFEF"
    },
    points: "237.6,214.4 257.6,234.4 277.6,214.4 218.4,97.6 159.2,214.4 179.2,234.4 199.2,214.4  218.4,234.4 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#7DD4E2"
    },
    points: "218.4,234.4 237.6,214.4 257.6,234.4 277.6,214.4 218.4,97.6 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.6,
    y: 328,
    style: {
      fill: "#057091"
    },
    width: 288,
    height: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F98D2B"
    },
    cx: 349.6,
    cy: 136,
    r: 37.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD6E12"
    },
    d: "M376.8,108.8c14.4,14.4,14.4,38.4,0,53.6s-38.4,14.4-53.6,0"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconimage);
export default __webpack_public_path__ + "static/media/iconimage.bca86b0215be0bce98041520d89a2636.svg";
export { ForwardRef as ReactComponent };